module.exports = __webpack_public_path__ + "static/fakenews-0df2fcfb762337b82ad2e31983731604.png";